import React from "react";
import Settings from "../../services/settings.service";
import Translation from "../../services/translation.service";

const DownloadMenuButton = () => {

    const detectAndRenderAppDownload = () => {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        let downloadLink = null; 
        let isMobile = Boolean(userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
        ))
        if(isMobile) {
            // Huawei Phone must come first because its UA also contains "Android"
            if (userAgent.includes("HUAWEI")) {
                downloadLink = Settings?.ob_app_gallery;
            } else if (userAgent.includes("Android")) {
                downloadLink = Settings?.ob_google_play;
            } else if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
                downloadLink = Settings?.ob_app_store;
            } else {
                //Any Other Device Detected
                downloadLink = null;
            }
        }
        return downloadLink;
    }
    
    return detectAndRenderAppDownload() && <li className="storefront-join-now">
        <a href={`${detectAndRenderAppDownload()}`}>
            {Translation.keys['stm_header_download_cta']}
        </a>
    </li>
}

export default DownloadMenuButton;